import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { getCookie } from "../../utils/cookie";
import { LOGOUT, getMeThunk, patchMeThunk } from "../../services/actions/user_actions";
import { RESET_CUSTOMER } from "../../services/actions/customer_actions";
import { useNavigate } from "react-router-dom";
import { checkInput, getDataFromRoutes, setMetaTags } from "../../utils/util_functions";
import { RESET_FIRMS } from "../../services/actions/firms_actions";
import { CLEAR_ORDERS } from "../../services/actions/orders_actions";
import {
  EDIT_FIRST_NAME, EDIT_LAST_NAME, EDIT_EMAIL, EDIT_SURNAME,
  EDIT_PHONE, SWITCH_PERM_MEDIUM_STATUS, CLEAR_PROFILE_FORM,
  SWITCH_PERM_NEWS, setCurrUserInProfile,
} from "../../services/actions/profile_form_actions";
import { getUser, getProfile, getCustomer, getRoutes } from "../../services/selectors";
import { getProductsThunk } from "../../services/actions/products_actions";
import { CLEAR_PATH_PARAMS } from "../../services/actions/path_params_actions";
import { USER_ROLES } from "../../utils/constants";
import { RESET_FIND_USER_INPUT } from "../../services/actions/find_user_actions";
import { CLEAR_CART } from "../../services/actions/cart_actions";
import { CLEAR_FAV } from "../../services/actions/fav_actions";


function EditProfile() {

  const {
    first_name, last_name, surname, email, phone, discount_level,
    role, perm_news, perm_system_messages
  } = useSelector(getUser);

  const {
    first_name_profile, last_name_profile, surname_profile,
    email_profile, phone_profile,
    perm_news_profile, perm_system_messages_profile
  } = useSelector(getProfile);

  const customer = useSelector(getCustomer);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [statusFirstName, setStatusFirstName] = useState({});
  const [statusLastName, setStatusLastName] = useState({});
  const [statusSurname, setStatusSurname] = useState({});
  const [statusPhone, setStatusPhone] = useState({});
  const [formValid, setFormValid] = useState(false);

  let accessToken = getCookie('accessToken') || '';
  let refreshToken = getCookie('refreshToken') || '';

  const routes = useSelector(getRoutes);
  const location = useLocation();

  useEffect(() => {
    dispatch({ type: CLEAR_PATH_PARAMS });
    const {
      metaTitle, metaDescription, metaKeywords, metaRobots
    } = getDataFromRoutes(location.pathname, routes);
    setMetaTags(
      metaTitle, metaDescription,
      metaKeywords, metaRobots
    )
    // eslint-disable-next-line
  }, [])

  useEffect(() => { window.scrollTo({ top: 0, left: 0 }) }, []);

  const changeFirstName = (e) => {
    if (e.target.value.length > 34) {
      e.target.value = e.target.value.slice(0, 34);
    }
    const currStatus = checkInput(e.target.value, 2, 34, 'string');
    setStatusFirstName({ ...statusFirstName, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_FIRST_NAME, first_name_profile: e.target.value });
  }
  const changeLastName = (e) => {
    if (e.target.value.length > 34) {
      e.target.value = e.target.value.slice(0, 34);
    }
    const currStatus = checkInput(e.target.value, 2, 34, 'string');
    setStatusLastName({ ...statusLastName, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_LAST_NAME, last_name_profile: e.target.value });
  }
  const changeSurname = (e) => {
    if (e.target.value.length > 34) {
      e.target.value = e.target.value.slice(0, 34);
    }
    const currStatus = checkInput(e.target.value, 2, 34, 'string');
    setStatusSurname({ ...statusSurname, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_SURNAME, surname_profile: e.target.value });
  }
  const changePhone = (e) => {
    if (e.target.value.length > 12) {
      e.target.value = e.target.value.slice(0, 12);
    }
    const currStatus = checkInput(e.target.value, 11, 12, 'tel');
    setStatusPhone({ ...statusPhone, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_PHONE, phone_profile: e.target.value });
  }

  const changePermNews = (e) => {
    dispatch({ type: SWITCH_PERM_NEWS, perm_news_profile: e.target.checked });
  }
  const changePermMediumStatuses = (e) => {
    dispatch({ type: SWITCH_PERM_MEDIUM_STATUS, perm_system_messages_profile: e.target.checked });
  }

  useEffect(() => {
    const validFirstName = checkInput(first_name_profile, 2, 34, 'string').valid;
    const validLastName = checkInput(last_name_profile, 2, 34, 'string').valid;
    const validSurname = checkInput(surname_profile, 2, 34, 'string').valid;
    const validPhone = phone_profile ? checkInput(phone_profile, 11, 12, 'tel').valid : true;

    setFormValid(
      validFirstName && validLastName && validSurname && validPhone
    );

    // eslint-disable-next-line
  }, [
    first_name_profile, last_name_profile, surname_profile,
    email_profile, phone_profile
  ]);


  useEffect(() => {
    if (accessToken && refreshToken) {
      dispatch(getMeThunk(accessToken, refreshToken, customer));
    } else {
      console.log('Кук нет');
      dispatch({ type: LOGOUT });
      dispatch({ type: RESET_CUSTOMER });
      dispatch({ type: RESET_FIRMS });
      dispatch({ type: CLEAR_ORDERS });
      dispatch({ type: CLEAR_PROFILE_FORM });
      dispatch({ type: CLEAR_CART });
      dispatch({ type: CLEAR_FAV })
      dispatch({ type: RESET_FIND_USER_INPUT });
      dispatch(getProductsThunk('', ''));
      navigate('/login', { state: { from: location } });
    }
    dispatch(
      setCurrUserInProfile(
        first_name, last_name, surname, email, phone, perm_news, perm_system_messages
      )
    );
    // eslint-disable-next-line
  }, []);


  const handleSubmit = (e) => {
    e.preventDefault();
    let data = {
      first_name: first_name_profile,
      last_name: last_name_profile,
      surname: surname_profile,
      perm_news: perm_news_profile,
      perm_system_messages: perm_system_messages_profile,
      phone: phone_profile
    }

    dispatch(patchMeThunk(
      accessToken, refreshToken, data
    ));
  }

  return (
    <>
      <form onSubmit={handleSubmit} className="form" noValidate>
        <label htmlFor="first_name_profile" className="label_text">
          Имя <span style={{ color: 'red' }}>*</span>
          <input
            type="text"
            id="first_name_profile" name="first_name_profile"
            value={first_name_profile}
            onChange={changeFirstName}
            className="input"
          />
          <p className="error">{statusFirstName?.text}</p>
        </label>
        <label htmlFor="last_name_profile" className="label_text">
          Фамилия <span style={{ color: 'red' }}>*</span>
          <input
            type="text"
            id="last_name_profile" name="last_name_profile"
            value={last_name_profile || ''}
            onChange={changeLastName}
            className="input"
          />
          <p className="error">{statusLastName?.text}</p>
        </label>
        <label htmlFor="surname_profile" className="label_text">
          Отчество <span style={{ color: 'red' }}>*</span>
          <input
            type="text"
            id="surname_profile" name="surname_profile"
            value={surname_profile || ''}
            onChange={changeSurname}
            className="input"
          />
          <p className="error">{statusSurname?.text}</p>
        </label>

        <label htmlFor="phone_profile" className="label_text">
          Телефон <span style={{ color: 'red' }}>*</span>
          <input
            type="tel"
            id="phone_profile" name="phone_profile"
            value={phone_profile || ''}
            onChange={changePhone}
            className="input"
          />
          <p className="error">{statusPhone?.text}</p>
        </label>
        <label htmlFor="email_profile" className="label_text">
          Email
          <input
            type="email"
            id="email_profile" name="email_profile"
            value={email}
            className="input"
            disabled
          />
        </label>
        <label htmlFor="discount_level" className="label_text">
          Уровень скидки
          <input
            type="text"
            id="discount_level" name="discount_level"
            value={discount_level}
            className="input"
            disabled
          />
        </label>
        {role !== USER_ROLES.customer &&
          <label htmlFor="role" className="label_text">
            Роль в системе
            <input
              type="text"
              id="role" name="role"
              value={role}
              className="input"
              disabled
            />
          </label>
        }
        <label htmlFor="perm_news" className="label_text">
          <input
            type="checkbox"
            id="perm_news" name="perm_news"
            className="checkbox"
            checked={perm_news_profile}
            onChange={changePermNews}
          />
          &emsp;Получать на email наши новости
        </label>
        <label htmlFor="perm_system_messages" className="label_text">
          <input
            type="checkbox"
            id="perm_system_messages" name="perm_system_messages"
            checked={perm_system_messages_profile}
            className="checkbox"
            onChange={changePermMediumStatuses}
          />
          &emsp;Получать на email системные сообщения и информацию о заказах
        </label>
        <button
          type="submit"
          className={`button ${!formValid ? 'button_disabled' : ''}`}
          disabled={!formValid}
        >
          Изменить данные
        </button>
      </form>
    </>
  );
}

export default EditProfile;
